import React from 'react';
import {TouchableOpacity, View, Platform} from 'react-native';
import {IStateProps} from './model';
import {images} from '../../../assets/icons';
import {useStyles} from '../../../shared/hooks/styles';
import {Text} from '../../../shared/components/text';

export function AccordionRewardShopView({expanded, onPress, title, children}: IStateProps) {
  const styles = useStyles(({theme}) => {
    return {
      arrow: {
        marginLeft: 'auto',
        transform: [{rotate: '-90deg'}],
        color: 'rgb(130, 130, 130)',
      },
      arrowActive: {
        marginLeft: 'auto',
        transform: [{rotate: '90deg'}],
      },
      accordionContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        minHeight: 'auto',
        backgroundColor: theme.color.backgroundMenuColor,
        padding: 10,
        borderRadius: 5,
        borderWidth: 1,
        borderColor: 'rgb(130, 130, 130)',
        borderStyle: 'solid',
        color: 'rgb(130, 130, 130)',
      },
      title: {
        color: 'rgb(130, 130, 130)',
        fontWeight: 'bold',
      },
    };
  });

  const {Left: Arrow} = images;

  return Platform.OS === 'web' ? (
    <div>
      <TouchableOpacity testID={`accordion-button-id`} onPress={onPress} style={{marginBottom: 15}}>
        <View style={styles.accordionContainer}>
          <Text type='h6Light' style={styles.title}>
            {title}
          </Text>
          <View style={[styles.arrow, expanded && styles.arrowActive]}>
            <Arrow width={20} height={20} color={styles.arrow.color} strokeWidth={3} />
          </View>
        </View>
      </TouchableOpacity>
      {expanded ? <View testID={`accordion-body-id`}>{children}</View> : null}
    </div>
  ) : (
    <View style={{alignSelf: 'flex-start'}}>
      <TouchableOpacity testID={`accordion-button-id`} onPress={onPress} style={{marginBottom: 15}}>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            minHeight: 'auto',
          }}>
          <Text type='h6Light' style={styles.title}>
            {title}
          </Text>
          <View style={[styles.arrow, expanded && styles.arrowActive]}>
            <Arrow width={20} height={20} color={styles.arrow.color} />
          </View>
        </View>
      </TouchableOpacity>
      {expanded ? <View testID={`accordion-body-id`}>{children}</View> : null}
    </View>
  );
}
